var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCirclesvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 101 100.73",
    style: {
      enableBackground: "new 0 0 101 100.73"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st50{fill:#999999;opacity:0.5}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M100.93,47.59c-0.42-7.92-2.73-15.74-6.7-22.61C90.27,18.12,84.66,12.2,78,7.88 c-6.65-4.32-14.34-7.04-22.23-7.87c-1.11-0.12-2.08,0.68-2.2,1.78s0.68,2.08,1.78,2.2c7.26,0.76,14.34,3.27,20.47,7.25 c6.13,3.98,11.29,9.42,14.94,15.75c3.65,6.33,5.79,13.52,6.17,20.82s-0.99,14.67-3.96,21.35c-0.45,1.01,0,2.19,1.01,2.64 c0.26,0.12,0.54,0.17,0.81,0.17c0.77,0,1.5-0.44,1.83-1.19C99.86,63.53,101.34,55.51,100.93,47.59z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M90.79,77.3c-0.89-0.65-2.14-0.46-2.8,0.43c-4.32,5.89-10.05,10.74-16.57,14.03 c-6.46,3.26-13.69,4.98-20.93,4.98c-0.07,0-0.14,0-0.2,0c-7.3-0.03-14.59-1.82-21.09-5.16c-6.49-3.34-12.18-8.25-16.45-14.17 c-0.64-0.9-1.89-1.1-2.79-0.46c-0.9,0.65-1.1,1.89-0.45,2.79c4.63,6.44,10.81,11.76,17.86,15.39c7.05,3.63,14.97,5.57,22.9,5.6 c0.07,0,0.15,0,0.22,0c7.86,0,15.71-1.87,22.73-5.4c7.08-3.57,13.3-8.84,18-15.23C91.88,79.21,91.68,77.96,90.79,77.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M4.06,47.8c0.38-7.29,2.51-14.49,6.17-20.82c3.65-6.32,8.82-11.77,14.94-15.75c6.12-3.98,13.2-6.48,20.46-7.25 c1.1-0.12,1.9-1.1,1.78-2.2c-0.12-1.1-1.1-1.9-2.2-1.78c-7.89,0.83-15.57,3.55-22.23,7.87c-6.65,4.32-12.26,10.23-16.23,17.1 c-3.97,6.87-6.28,14.69-6.7,22.61c-0.42,7.92,1.07,15.94,4.3,23.18c0.33,0.75,1.06,1.19,1.83,1.19c0.27,0,0.55-0.06,0.81-0.17 c1.01-0.45,1.46-1.63,1.01-2.64C5.05,62.48,3.68,55.09,4.06,47.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirclesvg);
export default __webpack_public_path__ + "static/media/circlesvg.f394aa51149e91d0ebc762e109cfabf0.svg";
export { ForwardRef as ReactComponent };